import React, { useState } from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { CgWebsite } from "react-icons/cg";
import "./projects.css";

function ProjectCards(props) {
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const { tags } = props;

  return (
    <>
      <Card className="project-card-view">
        <Card.Img variant="top" src={props.imgPath} alt="card-img" />
        <Card.Body>
          <Card.Title>{props.title}</Card.Title>
          {/* <Card.Text style={{ textAlign: "justify" }}>
            {props.description}
           
          </Card.Text> */}
          {/* <p className="projectTags"> {props.tags}</p> */}
          {/* Display tags with borders */}
          <div className="tags">
            {tags &&
              tags.map((tag, index) => (
                <span key={index} className="tag">
                  {tag}
                </span>
              ))}
          </div>
          {"\n"} {"\n"}
          {!props.isBlog && props.demoLink && (
            <Button
              variant="primary"
              onClick={handleOpenModal}
              style={{
                marginLeft: "10px",
                marginTop: "20px",
                marginBottom: "20px",
              }}
            >
              <CgWebsite /> &nbsp; {"More Details"}
            </Button>
          )}
        </Card.Body>
      </Card>

      {/* Modal for Demo */}
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        dialogClassName="custom-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title
            style={{
              fontSize: "22px",
              fontWeight: "600",
            }}
          >
            {props.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Add your images and text for the demo here */}
          {/* Example: */}
          <img
            src={props.imgPath}
            alt="Demo"
            style={{ width: "64%", display: "block", margin: "auto" }}
          />
          <p style={{ color: "#fff", textAlign: "justify" }}>
            {props.description}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <a href={props.demoLink} target="_blank" rel="noopener noreferrer">
            <Button variant="primary">Demo</Button>
          </a>

          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          {/* Add Demo Button */}
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ProjectCards;
